import { render, staticRenderFns } from "./TentList.vue?vue&type=template&id=6512851d&scoped=true"
import script from "./TentList.vue?vue&type=script&lang=ts"
export * from "./TentList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6512851d",
  null
  
)

export default component.exports